module.exports = __webpack_public_path__ + "img/dessert.46fa200c.svg";